/**
 * Compose the current string based on the previous and next strings
 * @param prev - previous string
 * @param next - next string, with the actual changes
 * @param current - current unmasked string
 * @returns new composed value
 */
export function reconcile(prev: string, next: string, current: string): string {
  // if the same, return current
  if (prev === next) { return current; }

  // represents the number of characters that are the same between prev and next in the left
  let startSlice = 0;
  // represents the number of characters that are the same between prev and next in the right
  let endSlice = 0;
  let charLimit = next.length;

  while (prev[startSlice] === next[startSlice] && charLimit > 0) {
    // eslint-disable-next-line no-plusplus
    startSlice++;
    // eslint-disable-next-line no-plusplus
    charLimit--;
  }

  while (prev[prev.length - 1 - endSlice] === next[next.length - 1 - endSlice] && charLimit > 0) {
    // eslint-disable-next-line no-plusplus
    endSlice++;
    // eslint-disable-next-line no-plusplus
    charLimit--;
  }

  // get the similar left part of the prev and next strings
  const left = startSlice > 0 ? current.slice(0, startSlice) : '';
  // get the similar right part of the prev and next strings
  const right = endSlice > 0 ? current.slice(-endSlice) : '';
  // get the middle part of the next string excluding the similar left/right parts
  const mid = next.slice(startSlice, -endSlice || next.length);

  const result = left + mid + right;
  return result;
}
